<template>
	<div class="family_index">
		<div class="family_index_header">
            <div class="mvbutton rule" @click="showrule=true">答题规则</div>
            <div class="family_index_header_notice">拍摄视频可以是以下是参考样式哦！</div>
            <div class="family_index_header_body">{{familyList.content}}</div>
        </div>        
        <div class="family_index_footer">
        	<div class="mvbutton return" @click="goback">
                返回首页
            </div>
            <div class="mvbutton continue " @click="goDetail">
                我去看看
            </div>
        </div>
		<van-overlay :show="showrule"  >
            <div class="wrapper">
                <div class="block">
                    <div class="block_header">
                        <div>规则说明</div>
                        <img :src="require('assets/img/mwap/colse.png')" alt="" @click="showrule = false">
                    </div>
                    <div class="block_body">{{rule}}</div>                    
                </div>                
            </div>
        </van-overlay>
	</div>
</template>
<script>
    import './index.less'
    import { Overlay } from 'vant';  
    export default {
        data(){
          return {
              familyList:{},
              rule:'',
              showrule:false
          }
        },
        components:{
            vanOverlay:Overlay
        },
        methods:{
            getFamilyList(){
                this.$api.family.familyList().then((res)=>{
                    if(res.status*1===200){
                        this.familyList  =   res.data
                        this.rule = res.data.rule
                    }

                })
            },
            goback(){
            	this.$router.push({name:'exchange',params:{id:3}})
            },
            goDetail(val){
                this.$router.push({name:'familydetail'})
            }
        },
        mounted(){
            this.$nextTick(()=>{
                this.getFamilyList();
            })
        }
    }
</script>